import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import BaladiyaUpdateDetails from "./BaladiyaUpdateDetails/BaladiyaUpdateDetails";
import { setAppError } from "../../../../../store/userSlice";
import nodeinstance from "../../../../../nodeInstance";
import DocumentUploadFilePopUp from "../../Iqama/FileDocumentPopUp/FileDocumentPopUp";

export default function ListBaladiyaAppliedList({
  token,
  titles = [],
  list = [],
  loading,
  updateData,
}) {
  const dispatch = useDispatch();

  const [listChecked, setItemList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [statusCode, setStatusCode] = useState();
  const [searchWords, setSearchWords] = useState([]);
  const [Popup, setPopUp] = useState(false);
  const [PopUpDoc, setPopUpDoc] = useState(false);
  const [popUpFlag, setPopUpFlag] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [selectList, setSelectList] = useState([]);
  const [baladiyaStatusValue, setBaladiyaStatusValue] = useState(0);

  var appliedTilteList = [
    "SR.NO.",
    "VISA PROVIDER",
    "CLIENT NAME",
    "Employee COUNT",
    "SPONSOR ID 700",
    "status",
  ];
  const [newCurrentList, setNewCurrentList] = useState([]);
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(newCurrentList || []);

  const apiCall = () => {
    updateData("123");
    setCheckedItems({});
  };

  const handleCheckboxChange = (event, employee_id, list) => {
    const isChecked = event.target.checked;
    setCheckedItems((prevState) => {
      const nextState = { ...prevState };
      if (isChecked) {
        nextState[employee_id] = true; // Set the checkbox state to true
      } else {
        delete nextState[employee_id]; // Remove the entry for unchecked checkboxes
      }
      return nextState;
    });
    setItemList((prevItemList) => {
      const updatedList = prevItemList.filter((item) => item !== list);
      if (isChecked) {
        updatedList.push(list);
      }
      return updatedList;
    });
  };

  const popOpen = () => {
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      if (dataList.length !== 0) {
        console.log(popUpFlag);
        if (popUpFlag === false) {
          console.log("popUpFlag", popUpFlag);
          baladiyaApi({
            employee_id: dataList.map((e) => e.employee_id),
            baladiya_status: statusCode,
          });
        } else {
          console.log("popUpFlag", popUpFlag);
          console.log(popUpFlag);
          setPopUp(true);
        }
      } else {
        dispatch(
          setAppError({
            msg: "Please Select Vaild Emp",
          })
        );
      }
    }
  };

  const popOpenCompleted = () => {
    const data = listChecked.filter((indexData) =>
      indexData.baladiya_status_value === null
        ? ""
        : indexData.baladiya_status_value.toString() === "5"
    );
    console.log(data, "API CALL TO BE SEEN HERE");
    setDataList(data);
    setPopUpFlag(false);
    setStatusCode("6");
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      if (data.length !== 0) {
        console.log(popUpFlag);
        if (popUpFlag === false) {
          console.log("popUpFlag", popUpFlag);
          baladiyaApi({
            employee_id: data.map((e) => e.employee_id),
            baladiya_status: statusCode,
          });
        } else {
          console.log("popUpFlag", popUpFlag);
          console.log(popUpFlag);
          setPopUp(true);
        }
      } else {
        dispatch(
          setAppError({
            msg: "Please Select Vaild Emp",
          })
        );
      }
    }
  };
  const baladiyaApi = async (type) => {
    try {
      const res = await nodeinstance.post("/baladiya/updatestatus/", type, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        setDataList([]);
        setCheckedItems({});
        updateData();
      } else {
        dispatch(
          setAppError({
            msg: err?.response?.error,
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error?.response?.error,
        })
      );
    }
  };

  const [indexValue, setIndex] = useState(10);
  console.log("listChecked to be seen in console", list);
  return (
    <>
      <div className="relative bg-white">
        <div className="overflow-x-auto max-h-[70vh]">
          <div className="sticky top-0 z-10 min-w-[1000px]">
            <div className="grid grid-cols-table-ajeer-applied gap-5 p-6 text-center">
              {appliedTilteList.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
            </div>
          </div>
          <div>
            {list?.isLoading && <LoadingWithLable className="col-span-6" />}
            {list?.isLoading && <NoDataFound />}
            {!list?.data?.listData?.isLoading
              ? list?.data?.listData.map((listData, index) => (
                  <a
                    key={index}
                    onClick={() => {
                      const filteredData = list?.data?.data.filter(
                        (indexData) =>
                          indexData.visa_provider === listData.visa_provider &&
                          indexData.client_name === listData.client_name &&
                          indexData.baladiya_status === listData.baladiya_status
                      );
                      if (listData.baladiya_status_value === 2) {
                        setSelectList([
                          { value: "REJECT" },
                          { value: "Update Details" },
                        ]);
                      }
                      setNewCurrentList(filteredData);
                      setIndex(index);
                      setBaladiyaStatusValue(listData.baladiya_status_value);
                    }}
                    className={`grid grid-cols-table-ajeer-applied gap-5 p-4   text-center ${indexValue === index ? "bg-orange-50" : "bg-white"} `}
                    style={{ cursor: "pointer" }} // Apply pointer cursor style
                  >
                    <React.Fragment key={index}>
                      <PaginationIndex index={index} />
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={listData.visa_provider || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={listData.client_name || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={
                            listData.employee_count.toString() || "-"
                          }
                        />
                      </p>
                      <p className="overflow-x-hidden">
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={listData.sponsor_id || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={listData.baladiya_status || "-"}
                        />
                      </p>
                    </React.Fragment>
                  </a>
                ))
              : ""}
          </div>
        </div>
      </div>
      {currentList.length !== 0 ? (
        <>
          <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
            <Search
              searchKey={[
                "employee_id",
                "visa_reference_number",
                "border_number",
              ]}
              setSearchWords={setSearchWords}
            />

            {newCurrentList[0].baladiya_status_value === 4 ? (
              <button
                className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                onClick={() => setPopUpDoc(true)}
              >
                <p>UPLOAD BULK DOCUMENT</p>
              </button>
            ) : (
              <></>
            )}
            {baladiyaStatusValue === 5 ? (
              <button
                className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                onClick={() => popOpenCompleted()}
              >
                <p>Update status baladiya completed</p>
              </button>
            ) : (
              <button
                className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                onClick={() => popOpen()}
              >
                <p>Update</p>
              </button>
            )}

            {baladiyaStatusValue === 5 ? (
              <></>
            ) : Object.entries(checkedItems)
                .filter(([emp_id, isChecked]) => isChecked)
                .map(([emp_id]) => emp_id).length !== 0 ? (
              <div className="">
                <select
                  className="select select-bordered select-sm w-full h-10"
                  defaultValue={{ label: "Choose", value: "placeholder" }}
                  onChange={(e) => {
                    setDataList([]);
                    const selectedValue = e.target.value;
                    if (selectedValue === "Update Details") {
                      setPopUpFlag(true);
                      const data = listChecked.filter((indexData) =>
                        indexData.baladiya_status_value === null
                          ? ""
                          : indexData.baladiya_status_value === 2
                      );
                      if (data.length !== 0) {
                        setPopUpFlag(true);
                        setDataList(data);
                      }
                    } else if (selectedValue === "REJECT") {
                      const data = listChecked.filter((indexData) =>
                        indexData.baladiya_status_value === null
                          ? ""
                          : indexData.baladiya_status_value.toString() === "2"
                      );
                      console.log(data);
                      setDataList(data);
                      setPopUpFlag(false);
                      setStatusCode("1");
                    } else {
                      setPopUpFlag(false);
                      setStatusCode("");
                      setDataList([]);
                    }
                  }}
                >
                  <option value="placeholder" hidden>
                    Choose
                  </option>
                  {selectList.map((value) => (
                    <option key={value.value} value={value.value}>
                      {value.value}
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              <></>
            )}
          </div>
          <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
          <CountPerPage />
          <div className="relative bg-white">
            <div className="overflow-x-auto max-h-[70vh] ">
              <div className="sticky top-0 z-10 bg-white min-w-[2700px]">
                <div className="grid grid-cols-table-baladiya-update gap-5 p-6 text-center">
                  {titles.map((t, index) => (
                    <p key={index} className="font-semibold uppercase">
                      {t}
                    </p>
                  ))}
                </div>
              </div>
              <div className="grid grid-cols-table-baladiya-update gap-5 p-6 bg-white text-center">
                {list?.isLoading && (
                  <LoadingWithLable className="col-span-full" />
                )}
                {!list?.isLoading && <NoDataFound />}
                {!list?.isLoading &&
                  currentList.map((list, index) => (
                    <React.Fragment key={index}>
                      <PaginationIndex index={index} />
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.employee_id || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.name || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.actual_profession || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_professions || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_provider || "-"}
                        />
                      </p>
                      <p className="overflow-x-hidden">
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.sponsor_id || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.client_name || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.iqama_number || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.baladiya_location || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.baladiya_apply_date || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.baladiya_issue_date || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.baladiya_expiry_date || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.baladiya_valid_days || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={
                            list.baladiya_status_value === null
                              ? ""
                              : list.baladiya_status_value.toString() === "2"
                                ? "Details Pending"
                                : list.baladiya_status || "-"
                          }
                        />
                      </p>
                      {newCurrentList[0].baladiya_status_value !== 4 &&
                      newCurrentList[0].baladiya_status_value !== 6 ? (
                        <div>
                          <input
                            // disabled={list.baladiya_status === "Baladiya Location Updated" ? true : false}
                            key={list.employee_id} // Use a unique identifier as the key
                            type="checkbox"
                            checked={checkedItems[list.employee_id] || false}
                            onChange={(event) =>
                              handleCheckboxChange(
                                event,
                                list.employee_id,
                                list
                              )
                            }
                          />
                        </div>
                      ) : (
                        <></>
                      )}

                      <hr
                        className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                      />
                    </React.Fragment>
                  ))}
              </div>
            </div>
          </div>
          <Pagination />
        </>
      ) : (
        <></>
      )}

      {Popup ? (
        <BaladiyaUpdateDetails
          list={listChecked.filter((indexData) =>
            indexData.baladiya_status_value === null
              ? ""
              : indexData.baladiya_status_value.toString() === "2"
          )}
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Update BALADIYA Details"}
          url={"/baladiya/update"}
          apiCall={apiCall}
        />
      ) : (
        ""
      )}

      {PopUpDoc ? (
        <DocumentUploadFilePopUp
          PopUp={PopUpDoc}
          setPopUp={setPopUpDoc}
          title={"Bulk Upload Documents"}
          url={`/baladiya/bulkuploadBaladiyaDoc/`}
          callBack={updateData}
          fileFormat={"> Baladiya-Iqama Number"}
          fileNme={"BALADIYA-Iqama Number"}
        />
      ) : (
        ""
      )}
    </>
  );
}
